import { render, staticRenderFns } from "./HistoryTypes.vue?vue&type=template&id=108b4d00&"
import script from "./HistoryTypes.vue?vue&type=script&lang=js&"
export * from "./HistoryTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports